import React from 'react'
import {useParams} from "react-router";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import {errorToast, successToast} from "../../../components/layout/ToastStyles";
import {Apis} from "../../../util/data";
import PageContainer from "../../../components/layout/PageContainer";
import PageSection from "../../../components/layout/PageSection";
import {PageBackLabel} from "../../../components/layout/PageBackLabel";
import PageTitle from "../../../components/layout/PageTitle";
import ConsejeriaRiskForm from "./ConsejeriaRiskForm";

const ConsejeriaRiskNew = () => {

  const navigate = useNavigate()

  const {id} = useParams()

  const onCreate = (data) => {
    axios.post(Apis.PROD + '/riesgo/' + id + '/consejerias/' + data.id)
      .then(res => {
        successToast("Consejeria del Riesgo creado correctamente")
        navigate('/riesgos/' + id + '/consejerias')
      })
      .catch(err => {
        errorToast(err.response.data.message, 6000)
      });
  }

  return (
    <PageContainer>
      <PageSection>
        <PageBackLabel text='Consejerias del Riesgo' onClick={() => navigate('/riesgos/' + id + '/consejerias')}/>
        <PageTitle title={'Consejeria del Riesgo'}/>
      </PageSection>

      <PageSection>
          <ConsejeriaRiskForm value={{}} onSubmit={(consej) => onCreate(consej)}/>
      </PageSection>
    </PageContainer>
  )
}

export default ConsejeriaRiskNew;
